module.exports = __webpack_public_path__ + "img/icon_monitor_size_4_hl.8654c557.webp";